import { makeStyles, createStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import mainImgMobile from 'assets/img/background/main_mobile.webp';
// import mainImgeDesktop from 'assets/img/background/main_desktop.webp';

export default makeStyles<Theme>(theme =>
  createStyles({
    root: {
      backgroundImage: `url(${mainImgMobile})`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center top -10px',
      backgroundSize: '712px auto',
      [theme.breakpoints.up('md')]: {
        backgroundImage: `none`
      }
    }
  }), { name: 'Main' }
);
